"use strict";
import { createGlobalStyle, css, keyframes } from "lib/styled-components";
export const flexColumnNoWrap = css`
  display: flex;
  flex-flow: column nowrap;
`;
export const flexRowNoWrap = css`
  display: flex;
  flex-flow: row nowrap;
`;
export var TRANSITION_DURATIONS = /* @__PURE__ */ ((TRANSITION_DURATIONS2) => {
  TRANSITION_DURATIONS2[TRANSITION_DURATIONS2["slow"] = 500] = "slow";
  TRANSITION_DURATIONS2[TRANSITION_DURATIONS2["medium"] = 250] = "medium";
  TRANSITION_DURATIONS2[TRANSITION_DURATIONS2["fast"] = 125] = "fast";
  return TRANSITION_DURATIONS2;
})(TRANSITION_DURATIONS || {});
export const transitions = {
  duration: {
    slow: `${500 /* slow */}ms`,
    medium: `${250 /* medium */}ms`,
    fast: `${125 /* fast */}ms`
  },
  timing: {
    ease: "ease",
    in: "ease-in",
    out: "ease-out",
    inOut: "ease-in-out"
  }
};
const fadeIn = keyframes`
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`;
export const textFadeIn = css`
  animation: ${fadeIn} ${transitions.duration.fast} ${transitions.timing.in};
`;
export const ThemedGlobalStyle = createGlobalStyle`
  html, body, #root {
    font-family: 'Darker Grotesque', Arial, sans-serif;
    color: ${({ theme }) => theme.neutral1};
    background-color: ${({ theme }) => theme.background} !important;
  }

  body {
    background-color: #000000;
    color: #fff;
  }

  /* Hide TradingView logo */
  #tv-attr-logo {
    display: none !important;
  }

  *, *::before, *::after {
    font-family: inherit;
  }

  code, pre {
    font-family: 'Source Code Pro', monospace;
  }

  h1, h2, h3, h4, h5, h6 {
    font-family: 'Darker Grotesque', Arial, sans-serif;
  }

  button, input, select, textarea {
    font-family: 'Darker Grotesque', Arial, sans-serif;
  }

  summary::-webkit-details-marker {
    display: none;
  }

  a {
    color: ${({ theme }) => theme.accent1};
  }
`;
